module.exports = __webpack_public_path__ + "img/served-food.b3a75540.svg";